import { createFileRoute } from "@tanstack/react-router";
import { CLIENT_TABS, ClientPage, type ClientTab } from "@/features/clients/ClientPage";

export const Route = createFileRoute("/_app/clients/$client/$tab")({ component: Page });

function Page() {
  const { client, tab } = Route.useParams();
  return <ClientPage slug={client} tab={(CLIENT_TABS as readonly string[]).includes(tab) ? (tab as ClientTab) : "overview"} />;
}
